<template>
  <v-app class="d-flex justify-space-between">
    <navigation
      v-if="isLogged"
      @mini="miniNavigation = $event"
    />
    <v-main>
      <router-view />
      <alerts-manager
        :mini="miniNavigation"
        :is-logged="isLogged"
      />
    </v-main>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        miniNavigation: false, // is navigation in mini mode
      }
    },
    computed: {
      title() {
        return this.$t('app_name');
      },
      permissions() {
        return this.$store.getters['auth/permissions'];
      },
      isLogged() {
        return this.$store.getters['auth/isLogged'];
      },
    },
    watch: {
      permissions: {
        immediate: true,
        handler() {
          this.updateAbility();
        }
      },
    },
    methods: {
      updateAbility() {
        this.$store.dispatch('auth/setUserPermissions', this.permissions);
      },
    },
  };
</script>
